import { inject, Injectable, isDevMode } from '@angular/core';
import { RemoteConfig } from '@angular/fire/remote-config';
import { fetchAndActivate, getBoolean, getNumber, getString } from 'firebase/remote-config';

@Injectable({ providedIn: 'root' })
export class RemoteConfigService {
  readonly #rc = inject(RemoteConfig);

  constructor() {
    // En dev: siempre fresco. En producción: cachea 5 minutos.
    this.#rc.settings.minimumFetchIntervalMillis = isDevMode() ? 0 : 5 * 60 * 1000;
  }

  async fetchAndGet(key: string): Promise<boolean> {
    await fetchAndActivate(this.#rc);
    return getBoolean(this.#rc, key);
  }

  async fetchAndGetString(key: string): Promise<string> {
    await fetchAndActivate(this.#rc);
    return getString(this.#rc, key);
  }

  async fetchAndGetNumber(key: string): Promise<number> {
    await fetchAndActivate(this.#rc);
    return getNumber(this.#rc, key);
  }
}
